import styled from "styled-components";
import { Modal } from "@bca/ui-library";
import theme from "../../styles/theme";

export const StyledSignModal = styled(Modal)`
  height: ${(props) => (props.isMobile ? "23.25rem" : "29.5rem")};
  width: ${(props) => (props.isMobile ? "22.188" : "46.563rem")};
`;

export const StyledSignatureContainer = styled.div`
  display: flex;
  border: 1px solid ${theme.color.blue};
  border-radius: 5px;
  margin: 2rem;
`;
